import { render } from "./QRcodeGenerator.vue?vue&type=template&id=bce9ea62"
import script from "./QRcodeGenerator.vue?vue&type=script&lang=js"
export * from "./QRcodeGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__